import { Grid, Skeleton, Stack } from '@mui/material';
import { withDefault } from '@vy/utils';
import React from 'react';
import { useGetCustomerContractsOverviewPage } from '../../../../../hooks/requests/use-get-customer-contracts-overview-page';
import { useValidatedParams } from '../../../../../hooks/use-validated-params';
import { CustomerActiveContracts } from './customer-overview-components/CustomerActiveContracts';
import { CustomerNotes } from './customer-overview-components/CustomerNotes/CustomerNotes';
import { FinancialInsights } from './customer-overview-components/FinancialInsights/FinancialInsights';

export const CustomerOverview: React.FC = () => {
  const { customerId } = useValidatedParams<['customerId']>('customerId');
  const { data, isLoading } = useGetCustomerContractsOverviewPage(customerId);

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        sx={{ padding: '32px 42px', minWidth: '592px', minHeight: '620px', height: '100%', gap: '20px' }}
      />
    );
  }

  return (
    <Grid container spacing={3} sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}>
      <Grid
        size={{
          md: 9
        }}>
        <Stack spacing="16px">
          <CustomerActiveContracts contracts={withDefault(data, [])} isLoading={isLoading} />
          <CustomerNotes customerId={customerId} />
        </Stack>
      </Grid>
      <Grid
        size={{
          md: 3
        }}>
        <FinancialInsights customerId={customerId} />
      </Grid>
    </Grid>
  );
};
